module.exports = __webpack_public_path__ + "img/Aksiyon-Brosur-Resim-Small.04a3486c.jpg";